/**
 * Nom de l'espace et environnement, affichés en tête du menu.
 *
 * Rien n'est écrit en dur : le produit est générique, et chaque client voit son
 * propre nom — la raison sociale saisie dans les Paramètres, à défaut le nom
 * donné à l'espace. L'étiquette (« PréProd »…) vient du serveur et n'existe
 * pas en production.
 *
 * Tant que la réponse n'est pas arrivée, ou si le compte n'a pas le droit de
 * lire l'identité de l'espace, le menu garde le nom du produit : un en-tête
 * vide serait pire qu'un en-tête générique.
 */
import { useCallback, useEffect, useState } from 'react';

import { api, type IdentiteEspace } from '../api/client';

/** Émis après l'enregistrement des Paramètres : le menu se relit aussitôt. */
export const IDENTITE_MODIFIEE = 'air:identite-espace-modifiee';

export const NOM_PRODUIT = 'Air Indu SaaS';

export function signalerIdentiteModifiee(): void {
  window.dispatchEvent(new Event(IDENTITE_MODIFIEE));
}

export function useIdentiteEspace(): IdentiteEspace | null {
  const [identite, setIdentite] = useState<IdentiteEspace | null>(null);

  const charger = useCallback(() => {
    api
      .identiteEspace()
      .then(setIdentite)
      .catch(() => {
        // Droit manquant ou réseau : on garde l'en-tête générique, sans
        // bloquer la navigation pour un simple libellé.
        setIdentite(null);
      });
  }, []);

  useEffect(() => {
    charger();
    window.addEventListener(IDENTITE_MODIFIEE, charger);
    return () => window.removeEventListener(IDENTITE_MODIFIEE, charger);
  }, [charger]);

  return identite;
}
